var render, staticRenderFns
import script from "./CorePivot.vue?vue&type=script&lang=js"
export * from "./CorePivot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e56ccaa')) {
      api.createRecord('7e56ccaa', component.options)
    } else {
      api.reload('7e56ccaa', component.options)
    }
    
  }
}
component.options.__file = "src/view/components/CorePivot.vue"
export default component.exports